
<h2 mat-dialog-title>Terms & Conditions</h2>

<mat-dialog-content>
  <p>These terms apply to all users as of 14th of April 2023.</p>

  <h3>Scope</h3>
  <p>These General Terms of Service (“Terms”) will be applied to an agreement between Arta Marketing AS, a
      Norwegian company, and a customer (“Customer”)
      to whom Arta Marketing provides cloud-based infrastructure and software services for the Customer's
      commercial purposes (“Service”). In these Terms, Arta Marketing and Customer are referred to jointly
      as the “Parties” and individually as a “Party”. The Parties expressly acknowledge that the
      Service is neither intended nor fit for use by consumers.</p>
  <h3>Agreement documents</h3>
  <p>An agreement is formed between the Parties when Arta Marketing receives an appropriately filled-in
      registration or order form (“Order”) which the Customer has submitted through a registration
      and/or purchasing procedure on Arta Marketing's website under the domain . In connection
      with the registration
      procedure the Customer will create a service account. Any referral herein to “Agreement”
      includes the Order, service descriptions attached or referred to in the Order, the service
      level agreement (“SLA”), the acceptable use policy (“AUP”) and these Terms. The SLA and the
      AUP are available on Arta Marketing's website under the domain .</p>
  <h3>Provision of service</h3>
  <p>Arta Marketing shall provide the Customer with the Service, which is specified in the Order. If the
      provided Service differs from the specifications, Arta Marketing shall correct the Service promptly
      after a notification by the Customer.</p>
  <h3>Service levels</h3>
  <p>Arta Marketing shall offer compensation to the Customer for all unscheduled interruptions in the
      provision of the Service in accordance with the SLA in force. In such cases, Arta Marketing will add
      free trial days to your subscription, not give a refund.</p>
  <h3>Support</h3>
  <p>Arta Marketing shall provide the Customer's administrative users with technical support with respect
      to the Service through the means described under the Support page on Arta Marketing's website under
      the domain .
      Contact details and service hours are provided on Arta Marketing's website under the domain
      .</p>
  <h3>Access to Service Account</h3>
  <p>The Customer will be responsible for activities that occur under the Customer's service
      account, including actions taken by the Customer's employees and other representatives
      (“User”) as well as their compliance with user instructions and the AUP. The Customer must
      promptly notify Arta Marketing if the Customer suspects that an unauthorised third party is using,
      or
      may have access to, the Service or the Customer's service account.</p>
  <h3>Third-party software</h3>
  <p>The Customer must comply with third-party software license terms if the use of such software
      is offered by Arta Marketing for the provision of the Service, or if such software is obtained and
      uploaded in the Service by the Customer, with Arta Marketing's separate instructions.</p>
  <h3>Paid subscriptions and free trials</h3>
  <p>The Service and the prices for the Service (“Service Fee”) are described in the service
      descriptions available on Arta Marketing's website under the domain . Arta Marketing may
      from time to time offer trials of the
      Service for a specified period without payment. Arta Marketing reserves the right, in its sole
      discretion, to determine Customer's eligibility for a free trial and, subject to applicable
      laws, to withdraw or to modify an offer trial at any time without prior notice and with no
      liability, to the greatest extent permitted under the law. For a free trial of the Service,
      Arta Marketing may require Customer to provide payment details to start the trial. At the end of
      such
      trial, Arta Marketing may automatically start to charge the applicable service fees for the Service
      immediately after the end of the free trial in accordance with Section Payment Terms and
      according to the price list on Arta Marketing's website under the domain . The applicable
      subscription to the Service
      must be cancelled through Customer's account's subscription page, or the Service must be
      terminated in its entirety, before the end of the trial period in case Customer does not
      accept the applicable prices provided on Arta Marketing's website under the domain .
      Customer shall ensure that the
      authorised Users use the Service in compliance with this Agreement. Misuse of the Service by
      Customer or any User may lead to termination of the Agreement or suspension or denial of
      access to the Service.</p>
  <h3>Right to use the Service and eligibility</h3>
  <p>Subject to due subscription to the Service and compliance with the Agreement, Arta Marketing grants
      to
      Customer a non-exclusive, nontransferable and limited right to enter and use the Service and
      grant Users access rights to the Service.</p>
  <h3>External Back-Up Copies</h3>
  <p>The Customer is responsible for making appropriate back-up copies of the Customer Data (as
      defined below) stored in the Service. Such back-up copies shall be stored outside the
      Service.</p>
  <h3>Changes to the Service</h3>
  <p>Arta Marketing is entitled to develop its services and business offerings. In case of a change in the
      Service, Arta Marketing will notify the Customer in advance. If Arta Marketing considers that a
      change will
      have a material effect in the Service, Arta Marketing will notify the Customer at least 30 days
      before the change will be effected and reserve the Customer a possibility to terminate the
      Agreement.</p>
  <h3>Prices</h3>
  <p>The prices of the Service are specified in the Order. Unless otherwise agreed, Arta Marketing charges
      the Customer in advance for each calendar month of the Service according to Arta Marketing's price
      list which is valid at the time and is available on Arta Marketing's website under the domain
      . Applicable value added
      tax and other duties will be added to the prices unless the prices are specified VAT
      inclusive.</p>
  <h3>Payment terms</h3>
  <p>Arta Marketing shall charge for the Service on a monthly or annual subscription based model, where
      the payment
      method associated with the subscription becomes automatically deducted in advance for one
      month/year at the time. Invoices are made available on the Customer's service account. To avoid
      being continously billed for any Service, it is the Customer's responsibility to delete and
      destroy any services the Customer no longer wants to be billed for. The Customer will be offered the
      opportunity to pay annually for a discounted price. In these cases, the Service has a commitment
      period.
      This means the Customer will not be refunded if the Customer chooses to terminate the plan early. In
      such a case,
      the Customer retains the right to use the Service until the date the subscription should've been
      renewed. With a monthly plan,
      the Service does not have a commitment period. In case of termination, the subscription will be
      cancelled and the Customer
      retains the right to use the Service until the date the next payment should've been made, had the
      Service not been terminated.</p>
  <h3>Customer's obligations and rights</h3>
  <p>When subscribing to the Service, Customer shall provide true, accurate and complete
      information as prompted by the Order and update such information when required. Please note
      that this Agreement only covers the Service and the use thereof and any and all linked third
      party services and platforms are provided by the relevant third parties and covered by their
      terms of service or other agreement or license. Arta Marketing does not assume any liability in
      regard to use of such third-party services and platforms, whether or not they are linked to
      the Service.</p>
  <h3>Use restrictions</h3>
  <p>Customer is not permitted and not entitled to permit the Users or any other parties to do any
      of the following:</p>
  <ul>
      <li>copy, redistribute, reproduce, record, transfer, perform or display to the public,
          broadcast, or make available to the public any part of the Service, or otherwise make
          any use of the Service which is not expressly permitted under the Agreement or
          applicable law or which otherwise infringes the intellectual property rights (such as
          copyright) in the Service or any part of it or any other intellectual property rights of
          third parties;</li>
      <li>use the Service in any manner that could damage, disable, overburden or impair the
          Service available through the Service;</li>
      <li>use any data mining, robots, scraping, or similar data gathering or extraction methods
          which is not expressly permitted under the Agreement;
      </li>
      <li>sign up for an account on behalf of someone else;</li>
      <li>use, sell, rent, transfer, license or otherwise provide anybody with the Service, except
          as provided herein without Arta Marketing's written consent; </li>
      <li>interfere with other Customers' use and enjoyment of the Service;</li>
      <li>circumvent or try to circumvent any usage control or anti-copy functionalities of the
          Service;</li>
      <li>reverse engineer or decompile the Service or access the source code thereof, except as
          permitted by law;</li>
      <li>use the Service for transmitting any unauthorised advertising, promotional materials,
          junk mail, spam, chain letters, contests, pyramid schemes, or any other form of
          solicitation or mass messaging;</li>
      <li>use the Service in violation of applicable law;</li>
      <li>use the Service in ways that violate intellectual property rights, business secrets or
          privacy of third parties; </li>
      <li>use the Service to transmit any material that contains adware, malware, spyware,
          software viruses, worms or any other computer code designed to interrupt, destroy, or
          limit the functionality of computer software or equipment. </li>
  </ul>
  <h3>Customer Data</h3>
  <p>Customer data shall mean all Customer's data that a Customer or another party acting on
      Customer's behalf generates in or submits to the Service (“Customer Data”) or the data
      Customer submits to a third-party service or platform which might be accessed by the
      Service, subject to and on the basis of the permissions or consents Customer has granted.
      Customer agrees that Arta Marketing does not assume any liability or responsibility in respect to
      any
      Customer Data, with the exceptions relating to Personal Data as set forth in Section Data
      Processing below. Customer shall at all times ensure that Customer Data does not infringe
      any third party intellectual property rights or violate any applicable laws or legislation.
      Customer shall not upload any illegal, offensive, threatening, libellous, defamatory, or
      otherwise inappropriate data to the Service. For clarity, Arta Marketing is not responsible and
      shall
      not be held liable for any Customer Data, nor does it endorse any opinion contained in any
      Customer Data. Aside from the rights specifically granted herein, Customer retains ownership
      of all rights, including intellectual property rights, in the Customer Data.</p>
  <h3>Data processing</h3>
  <p>In order to provide the Service, Arta Marketing may process personal data on behalf of the Customer
      as
      a data processor for the purposes of providing the Service. Arta Marketing processes certain
      personal
      data also as a data controller. Such personal data includes, inter alia, data of the
      Customer's contact persons, invoicing details and other personal data of Customer's contact
      persons which Arta Marketing processes in order to maintain the customer relationship. The
      requirements relating to the personal data Arta Marketing processes as data controller are set out
      in
      our Privacy Policy available on Arta Marketing's website under the domain . In this
      section, “Personal Data” refers to
      any information relating to an identified or identifiable natural person the Customer enters
      into the Service and Arta Marketing processes on behalf of the Customer in the course and within the
      scope of providing the Services. In connection with the use of the Service, the Customer may
      transfer various data to Arta Marketing for processing on behalf of the Customer. Such data might
      include Personal Data. The Customer shall be considered as the sole data controller and
      Arta Marketing as the sole data processor with respect to such data. The following terms and
      conditions set forth in this section concern the data processing activities of Arta Marketing as a
      data processor with respect to the Personal Data it processes on behalf of the Customer.</p>
  <h3>General requirements relating to processing of Personal Data</h3>
  <p>The Customer shall be responsible for the lawful collection, processing and use, and for the
      accuracy of the Personal Data, as well as for preserving the rights of the individuals
      concerned. If and to the extent legally required, the Customer shall inform the individuals
      concerned regarding the processing of their Personal Data by Arta Marketing, and shall obtain their
      consent if necessary. The Personal Data processed by Arta Marketing on behalf of the Customer may
      include e.g. Personal Data of the Customer's employees and end-customers, such as contact
      details of the aforementioned data subjects. The Customer acknowledges that due to the
      nature of the Service, Arta Marketing cannot control and has no obligation to verify Personal Data
      the Customer transfers to Arta Marketing for processing on behalf of the Customer when the Customer
      uses the Service. The Customer ensures that the Customer is entitled to transfer the
      Personal Data to Arta Marketing so that Arta Marketing may lawfully process the Personal Data on
      behalf of the
      Customer in accordance with this Agreement. Arta Marketing shall not use Personal Data for any
      purpose other than that of rendering and providing the Service and will not assert liens or
      other rights over, or sell or disclose the Personal Data to any third parties, without the
      Customer's prior written approval. Arta Marketing shall process Personal Data in accordance with
      this
      Agreement and documented instructions from the Customer. The Customer's instructions must be
      commercially reasonable, compliant with applicable data protection laws and consistent with
      this Agreement. Arta Marketing shall not be obliged to verify whether any instructions given by the
      Customer are consistent with applicable laws, as the Customer is responsible for such
      compliance verification of its instructions. However, if Arta Marketing detects that any instruction
      given by the Customer is noncompliant with the requirements of any data protection
      legislation applicable to Arta Marketing's operations, Arta Marketing shall inform the Customer in
      writing.
      Arta Marketing and the Customer shall comply with the EU Regulation 2016/679 on the protection of
      natural persons with regard to the processing of personal data and on the free movement of
      such data (“Regulation”) and any applicable European or foreign data protection laws as
      amended, as well as data protection authorities' orders and guidelines. Arta Marketing and the
      Customer shall implement and maintain appropriate technical and organisational security
      measures to protect the Personal Data within their area of responsibility, in order to
      safeguard the Personal Data against unauthorised or unlawful processing or access and
      against accidental loss, destruction or damage. Such measures include where necessary and
      appropriate, taking into account the state of the art, the costs of implementation and the
      nature, scope, context and purposes of processing as well as the risk of varying likelihood
      and severity for the rights and freedoms of natural persons the following measures:</p>
  <ul>
      <li>access right controls to systems containing Personal Data;</li>
      <li>the pseudonymisation and encryption of Personal Data;</li>
      <li>the ability to ensure the ongoing confidentiality, integrity, availability and
          resilience of processing systems and services;</li>
      <li>the ability to restore the availability and access to Personal Data in a timely manner
          in the event of a physical or technical incident;</li>
      <li>a process for regularly testing, assessing and evaluating the effectiveness of technical
          and organisational measures for ensuring the security of the processing.</li>
  </ul>
  <h3>Arta Marketing's assistance obligations</h3>
  <p>To respond to requests from individuals exercising their rights as foreseen in applicable
      data protection law, such as the right of access and the right to rectification or erasure,
      the Customer shall primarily use the corresponding functions of the Services, such as the
      Arta Marketing HUB. Arta Marketing shall provide the Customer with commercially reasonable
      assistance, without
      undue delay, taking into account the nature of the processing. Arta Marketing shall further provide
      the Customer with commercially reasonable assistance in ensuring compliance with the
      Customer's obligations to perform security and data protection assessments, breach
      notifications and prior consultations of the competent supervisory authority, as set out in
      the applicable data protection law, taking into account the nature of the processing and the
      information available to Arta Marketing. In case such assistance requires extensive measures from
      Arta Marketing, the Customer shall pay additional reasonable remuneration to Arta Marketing for
      handling such
      assistance requests. In addition, Arta Marketing shall, and shall procure that its personnel
      (including its subcontractors' personnel) shall:</p>
  <ul>
      <li>only process Personal Data in accordance with the Customer's written instructions and
          not for Arta Marketing's own purposes;</li>
      <li>ensure that individuals processing Personal Data have committed themselves to
          confidentiality or are under an appropriate statutory obligation of confidentiality.
      </li>
  </ul>
  <h3>Transfers of Personal Data</h3>
  <p>The Customer accepts that Arta Marketing may have Personal Data processed and accessible by its
      subprocessors outside the Customer's country of domicile to provide the Service. In case the
      processing is subject to any EU data protection law and Personal Data is transferred from
      the European Economic Area (“EEA”) to a subprocessor for processing in any country outside
      the EEA that is not recognised by the European Commission as providing an adequate level of
      protection for personal data, Arta Marketing provides for appropriate safeguards by standard
      contractual clauses, adopted or approved by the European Commission and applicable to the
      processing by the nonEEA subprocessor or by any other appropriate safeguard as foreseen
      under Regulation.</p>
  <h3>Audits</h3>
  <p>The Customer shall have the right to audit the facilities and processing activities of Arta Marketing
      under this Agreement to examine the level of protection and security provided for Personal
      Data processed under this Agreement and to assess the compliance of Arta Marketing with the terms
      and
      conditions relating to Personal Data set out herein. Each Party shall bear its own costs for
      any such audit. Where an audit may lead to the disclosure of business or trade secrets of
      Arta Marketing or threaten intellectual property rights of Arta Marketing, the Customer shall employ
      an
      independent expert to carry out the audit, and the expert shall agree to be bound to
      confidentiality to Arta Marketing's benefit.</p>
  <h3>Subprocessors</h3>
  <p>General authorisation. The Customer gives its general authorisation to allow Arta Marketing to
      involve
      Arta Marketing's affiliated companies and other subcontractors as subprocessors to process Personal
      Data in connection with the provision of the Service, to the extent such appointment does
      not lead to noncompliance with any applicable law or Arta Marketing's obligations under this
      Agreement. Arta Marketing ensures that the involved subprocessors are properly qualified, will be
      under a data processing agreement with Arta Marketing, and comply with data processing obligations
      similar to the ones which apply to Arta Marketing under this Agreement. Arta Marketing shall be
      liable towards
      the Customer for the processing of Personal Data carried out by Arta Marketing's subprocessors.</p>
  <h3>Change of subprocessor</h3>
  <p>Arta Marketing is free to choose and change its subprocessors. Upon request, Arta Marketing shall
      inform the
      Customer of subprocessors currently involved. In case there is a later change of
      subprocessor (addition or replacement), Arta Marketing shall notify the Customer of such change. In
      case the Customer objects such change of subprocessor on reasonable grounds, the Customer
      has the right to request change of the subprocessor. If Arta Marketing is not willing to change the
      subprocessor the Customer has objected, the Customer shall have the right to terminate the
      Service and this Agreement.</p>
  <h3>Breaches</h3>
  <p>Arta Marketing shall, without undue delay after having become aware of it, inform the Customer in
      writing about any data breaches relating to Personal Data and any other events where the
      security of Personal Data processed on behalf of the Customer has been compromised. Arta Marketing's
      notification about the breach to the Customer shall include at least the following:</p>
  <ul>
      <li>description of the nature of the breach;</li>
      <li>name and contact details of Arta Marketing's contact point where more information can be
          obtained;</li>
      <li>description of the measures taken by Arta Marketing to address the breach, including, where
          appropriate, measures to mitigate its possible adverse effects.</li>
  </ul>
  <h3>Deletion and return of Personal Data</h3>
  <p>Arta Marketing shall not take any action to intentionally erase any Personal Data processed on behalf
      of the Customer, without the Customer's explicit request. Personal Data shall be processed
      under this Agreement until the Customer has ceased to use the Service. Within a reasonable
      time after the termination or expiry of this Agreement, or after the Customer has
      permanently ceased to use the Service, Arta Marketing shall permanently delete Personal Data from
      its
      storage media, except to the extent that Arta Marketing is under a statutory obligation to continue
      storing such Personal Data. On the Customer's request, Arta Marketing shall confirm the deletion in
      writing. The obligation to delete Personal Data shall not apply to Personal Data contained
      in regular back-up copies of comprehensive datasets from which the individual deletion of
      Personal Data would not be possible without significant efforts or costs.</p>
  <h3>Intellectual Property Rights</h3>
  <p>All intellectual property rights to and in the Service as well as intellectual property
      rights pertaining thereto, are exclusive property of Arta Marketing or its licensors with all rights
      reserved. All intellectual property rights to the content uploaded into the Service by or on
      behalf of the Customer will remain the exclusive property of the Customer or its licensors.
      All intellectual property rights relating to the provision of the Services, including
      suggestions for improvements made by the Customer, will remain the exclusive property of
      Arta Marketing or its licensors.</p>
  <h3>Limited Warranty</h3>
  <p>Arta Marketing will offer service level compensations to the Customer in accordance with the SLA. In
      all other respects the Service is provided on “as-is” and “as-available” basis, and Arta Marketing
      will not give the Customer any warranty or guarantee, express or implied, for the Service,
      including but without limitation to warranties of merchantability, fitness for any
      particular purpose, performance, or noninfringement. The parties expressly note that the
      Service is not designed to be error-free or uninterrupted and therefore they are neither
      intended nor fit for purposes that require fail-safe performance.</p>
  <h3>Limited Liability</h3>
  <p>Arta Marketing will not be liable for indirect damage or consequential damages caused to the
      Customer.
      Arta Marketing's total aggregate liability under or in connection with this Agreement shall be
      limited to the aggregate Service Fee paid by the Customer for the Service for the last six
      (6) months preceding the occurrence for which damages are claimed. These limitations will
      not apply to damage caused by wilful misconduct or gross negligence. In order to be valid
      and enforceable, all claims for damages must be made within 30 days from the date the damage
      was or should reasonably have been noticed by the Customer.</p>
  <h3>Assignment and Third-Party Benefits</h3>
  <p>Arta Marketing may assign the Agreement in whole or in part to another group company or in connection
      with the trade sale which includes the provision of the Service. The Customer may assign the
      Agreement to a third party with Arta Marketing's prior written consent which Arta Marketing will not
      unreasonably withhold. The Agreement will not create any third-party beneficiary rights in
      any third party.</p>
  <h3>Temporary Suspension</h3>
  <p>If the Customer has breached the provisions of the Agreement or Arta Marketing has justifiable
      reasons
      to believe such a breach exists, Arta Marketing may temporarily suspend the provision of the
      Service.
  </p>
  <h3>Termination for Convenience</h3>
  <p>The Customer may terminate the Agreement for any reason by issuing 5 days written notice to
      Arta Marketing. Any payment made will not be refunded, but the subscription will be cancelled.
      Arta Marketing may terminate the Agreement for any reason by issuing 30 days written notice to
      the Customer.</p>
  <h3>Termination for Cause</h3>
  <p>Either Party may terminate the Agreement with immediate effect if the other Party has
      materially breached the provisions of the Agreement.</p>
  <h3>Transition Service</h3>
  <p>Arta Marketing will provide the Customer with transition services in order to enable the Customer to
      transfer the Customer Data to another service provider. The Customer must order the
      transition services before the termination of the Agreement. The description of the
      transition services and applicable prices are provided on Arta Marketing's website under the domain
      .</p>
  <h3>Entire Agreement and Amendments</h3>
  <p>The Agreement constitutes the entire agreement and supersedes all previous commitments
      between the parties in respect of the provision of the Service. All amendments to the
      Agreement must be made in writing. Arta Marketing may modify this Agreement by notifying the
      Customer
      in writing, such as by e-mail or by posting a revised document version on Arta Marketing's website.
      If Arta Marketing considers that a revision will have a material effect on the Agreement, Arta
      Marketing will
      notify the Customer at least 30 days before the revision will be effected and reserve the
      Customer a possibility to terminate the Agreement.</p>
  <h3>Non-Waiver</h3>
  <p>A failure by either Party to enforce any provision of the Agreement will not be deemed to
      constitute a present or future waiver of such provision. All waivers must be made in
      writing.</p>
  <h3>Force Majeure</h3>
  <p>Force Majeure is an event that prevents, or makes unduly difficult, the performance of the
      Service or the fulfilment of the provisions of the Agreement, such as war, rebellion,
      natural catastrophe, general interruption in energy distribution or telecommunications,
      fire, strike, embargo, or another equally significant and unforeseen event independent of
      the parties. Each Party shall be entitled to suspend its duties without liability thereof in
      case of Force Majeure affecting the Party either directly or through its subcontractor.</p>
  <h3>Severability</h3>
  <p>Should any provision of the Agreement be declared unenforceable by a court of competent
      jurisdiction, the remaining provisions of the Agreement will remain in full force and effect
      to the fullest extent permitted by law. The Parties shall attempt through negotiation in
      good faith to replace the unenforceable provision with such provisions that correspond as
      closely as possible to the original intention of the Parties.</p>
  <h3>Governing Law and Arbitration</h3>
  <p>The Agreement will be governed by the substantive laws of Norway, with the
      exception of any conflict of law principles. Any and all disputes, which the Parties fail to
      settle amicably, arising out of or relating to the Agreement will be finally settled by
      arbitration in English language.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">

  <button
    mat-flat-button
    [mat-dialog-close]="true">
    Close
  </button>

</mat-dialog-actions>
